export default __webpack_public_path__ + "static/media/6c.fd20c095.png";